import * as React from 'react';
import styled, { keyframes, withTheme } from 'styled-components';
import { rem } from 'polished';
import { __ } from 'react-i18n';
import { StyledTableRow } from '../../Product/ProductTabRowTable';
import { ZemplinLoaderWrapper } from '../../../..';
import { TableWrapper } from '../../General/TableWrapper';
import { FlexRow } from '../../../Defaults/Flexbox/Flexbox';
import {
  isOrderingLessThanMinimum,
  getElasticCategoryZemplinProductInfo,
} from '../../selectors';
import { TableTh, TableTd } from '../../General/Table';
import { ModalItemsTabRow } from './ModalItemsTabRow';
import { ModalItemMobile } from './ModalItemMobile';

interface Props {
  products: any;
  isFetching: boolean;
  theme: any;
  refreshCart: () => void;
  count: string;
  handleCountChange: any;
  isLoggedIn: boolean;
  isFromCategory?: boolean;
}

function ModalItemsTable({
  products,
  isFetching,
  theme,
  count,
  isLoggedIn,
  handleCountChange,
  isFromCategory,
}: Props) {
  const totalPriceText = isLoggedIn ? __('bez DPH') : __('s DPH');

  const COLUMNS = [
    { name: `Cena ${totalPriceText}`, align: 'right' },
    { name: 'Množstvo', align: 'center' },
    { name: 'Balenie' },
    { name: `Spolu ${totalPriceText}` },
  ];

  const productsComponent =
    products &&
    products.map((p: any, i) => (
      <StyledTableRow key={p.product_id}>
        <ModalItemsTabRow
          count={count}
          handleCountChange={handleCountChange}
          product={p}
          isLoggedIn={isLoggedIn}
          isFromCategory={isFromCategory}
        />
      </StyledTableRow>
    ));

  const mobileProductsComponent =
    products &&
    products.map((p: any, i) => (
      <ModalItemMobile
        count={count}
        handleCountChange={handleCountChange}
        key={p.product_id}
        product={p}
        isLoggedIn={isLoggedIn}
        isFromCategory={isFromCategory}
      />
    ));

  const headers =
    COLUMNS &&
    COLUMNS.map((item: any, i) => (
      <StyledTableTh
        width={item.width}
        minWidth={item.minWidth}
        align={item.align || 'left'}
        key={i}
      >
        {item.name}
      </StyledTableTh>
    ));

  return (
    <Wrapper>
      <DesktopListProductsWrapper>
        <TableWrapper
          noItemsText={__('Nenašli sa produkty')}
          headers={headers}
          rows={productsComponent}
        />
      </DesktopListProductsWrapper>
      <MobileListProductsWrapper>
        {mobileProductsComponent}
      </MobileListProductsWrapper>
    </Wrapper>
  );
}

const Wrapper = styled(FlexRow)`
  flex-flow: row wrap;

  ${({ theme }) => theme.mediab.m810`
     margin-bottom: 0;
  `}
`;

const DesktopListProductsWrapper = styled.div`
  display: block;
  width: 100%;

  ${({ theme }) => theme.mediab.m810`
    display: none;
  `}
`;

const MobileListProductsWrapper = styled.div`
  display: none;
  width: 100%;

  ${({ theme }) => theme.mediab.m810`
      display: flex;
      justify-content: center;
      flex-flow: column;
  `}
`;

const StyledTableTh = styled(TableTh)`
  padding-bottom: ${rem(24)};
`;

const WithTheme: any = withTheme(ModalItemsTable);
export { WithTheme as ModalItemsTable };
